import { z } from 'zod';

import { defaultPagingSchema } from '../../../../helpers/schemas/defaultPagingSchema';
import { getOnboardingApplicationsFilterFormSchema } from '../helpers/getOnboardingApplicationsFilterFormSchema';

const onboardingApplicationsFilterFormSchema =
	getOnboardingApplicationsFilterFormSchema();

export const onboardingApplicationsValidateSearchSchema =
	defaultPagingSchema.extend({
		openedApplicationUuid: z.string().optional(),
		filter: onboardingApplicationsFilterFormSchema.optional().prefault({}),
	});
